import { render, staticRenderFns } from "./link_detail.vue?vue&type=template&id=55c7db24&scoped=true&"
import script from "./link_detail.vue?vue&type=script&lang=js&"
export * from "./link_detail.vue?vue&type=script&lang=js&"
import style0 from "./link_detail.vue?vue&type=style&index=0&id=55c7db24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c7db24",
  null
  
)

export default component.exports